import { render } from "./staff_bankcard.vue?vue&type=template&id=ebc11cba&scoped=true"
import script from "./staff_bankcard.vue?vue&type=script&lang=js"
export * from "./staff_bankcard.vue?vue&type=script&lang=js"

import "./staff_bankcard.vue?vue&type=style&index=0&id=ebc11cba&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc11cba"]])

export default __exports__